import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddNewCountry, getCountryList, getHotelList, UpdateCountryStatus, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";
import { useNavigate } from "react-router-dom";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper.js";
import { isEmpty } from "../../../utils/common.js";



const AddCountry = () => {

      const [newCountryData, setNewCountryData] = useState({
          countryName: null,
          iso2: null,
          iso3: null,
          phoneCode: null,
          active: null,
      });
    
      const [errors, setErrors] = useState({});
      const [loading,setLoading] = useState(false);
      const[message,setMessage] = useState("");

      const validateForm = () => {
        const newErrors = {};
        if (!newCountryData.countryName) {
            newErrors.countryName = "Country Name is required";
        }
        if (!newCountryData.iso2) {
            newErrors.iso2 = "ISO2 Code is required";
        } else if (newCountryData.iso2.length !== 2) {
            newErrors.iso2 = "ISO2 Code must be 2 characters";
        }
        if (!newCountryData.iso3) {
            newErrors.iso3 = "ISO3 Code is required";
        } else if (newCountryData.iso3.length !== 3) {
            newErrors.iso3 = "ISO3 Code must be 3 characters";
        }
        if (!newCountryData.phoneCode) {
            newErrors.phoneCode = "Phone Code is required";
        } else if (!/^\d+$/.test(newCountryData.phoneCode)) {
            newErrors.phoneCode = "Phone Code must be numeric";
        }
        if (newCountryData.active === "") {
            newErrors.active = "Status is required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

      const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setNewCountryData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleSubmit = () => {
        if (validateForm()) {
            AddNewCountry(newCountryData).then((resp) => {
                if (resp?.success) {
                    setMessage({type:"success",message:"Country Added successfully!"});

                   // showCountryList(0); // Refresh the list
                   // setCountry(false); // Close the modal
                }
               
            });
        }
    };

    return(
        <>

    <div className="main_container">
    {!isEmpty(message) && (
              <AlertWrapper className={`${message.type} globle`}>
                <span className="close" onClick={() => setMessage({})}>
                  ×
                </span>
                {message.message}
              </AlertWrapper>
            )}
      <div className="userlist_head">

      <div className="userlist_heading">
              <div className="userlist_left">
                <label>Add New Country</label>
              </div>
      </div>
      </div>
       <div className="subadmin_container justify-between flex column gap-20">
         <div style={{padding:"30px",flex:"1 1 100%"}}>
          
       <div className="flex gap-10">

          <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Country Name:</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Country Name"
                  name="countryName"
                value={newCountryData?.countryName}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.countryName && (
                  <p className="error fs-12 mt-10">{errors.countryName}</p>
                )}
              </div>

              <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                  <label className="fw-bold">Status:</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                    value={newCountryData?.active}
                  onChange={handleModalInputChange}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">Select Status</option> 
                     <>
                      <option value={true}>ACTIVE</option>
                     <option value={false}>INACTIVE</option>
                      </>
                    </select>
                    {errors.active && (
                  <p className="error fs-12 mt-10">{errors.active}</p>
                )}
                  </div>
                 
          </div>
        

          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Iso2:</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Iso2"
                  name="iso2"
               value={newCountryData?.iso2}
                onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.iso2 && (
                  <p className="error fs-12 mt-10">{errors.iso2}</p>
                )}
              </div>

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Iso3:</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Iso3"
                  name="iso3"
                 value={newCountryData?.iso3}
                 onChange={handleModalInputChange}
                 
                 // click={checkStatus}
                />
                {errors.iso3 && (
                  <p className="error fs-12 mt-10">{errors.iso3}</p>
                )}
              </div>
          </div>

          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Phone Code:</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Phone Code"
                  name="phoneCode"
                value={newCountryData?.phoneCode}
                  onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.phoneCode && (
                  <p className="error fs-12 mt-10">{errors.phoneCode}</p>
                )}
              </div>

             
          </div>

       
          <div>
          <button onClick={handleSubmit} className="userlist_btn mt-20">Submit</button>
        </div>
         </div>
       
         
        
       
       
         </div>
       

         </div>

       
        
        </>
    )

}
export default AddCountry;